var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.header)?[_vm._v(" "+_vm._s(_vm.$t(("global." + _vm.header)))+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }